/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "contract IResolver",
                name: "resolver",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "releaseVersion",
                type: "string",
            },
        ],
        name: "loadFramework",
        outputs: [
            {
                components: [
                    {
                        internalType: "contract ISuperfluid",
                        name: "superfluid",
                        type: "address",
                    },
                    {
                        internalType: "contract ISuperTokenFactory",
                        name: "superTokenFactory",
                        type: "address",
                    },
                    {
                        internalType: "contract ISuperAgreement",
                        name: "agreementCFAv1",
                        type: "address",
                    },
                    {
                        internalType: "contract ISuperAgreement",
                        name: "agreementIDAv1",
                        type: "address",
                    },
                    {
                        internalType: "contract ISuperAgreement",
                        name: "agreementGDAv1",
                        type: "address",
                    },
                ],
                internalType: "struct SuperfluidLoader.Framework",
                name: "result",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class SuperfluidLoader__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(resolver, overrides) {
        return super.deploy(resolver, overrides || {});
    }
    getDeployTransaction(resolver, overrides) {
        return super.getDeployTransaction(resolver, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
SuperfluidLoader__factory.bytecode = _bytecode;
SuperfluidLoader__factory.abi = _abi;
//# sourceMappingURL=SuperfluidLoader__factory.js.map